import { useEffect } from "react";
import { Control, FieldValues, UseFormReset, useWatch } from "react-hook-form";

export const useStaleDataFormReset = <TFieldValues extends FieldValues>(
    control: Control<TFieldValues>,
    reset: UseFormReset<TFieldValues>,
    initialValues: TFieldValues
) => {
    const currentForm = useWatch({ control });

    useEffect(() => {
        // If initialValues change, e.g. if SWR has given stale data, we need to reset the form
        const checkIfFormShouldReset = async () => {
            // this prevents the first initial values from triggering a reset
            await new Promise((resolve) => setTimeout(resolve, 0));

            const stringForm = JSON.stringify(currentForm);
            const stringInitialValues = JSON.stringify(initialValues);
            const formShouldReset = !(stringForm === stringInitialValues);
            if (formShouldReset) {
                reset(initialValues);
            }
        };
        checkIfFormShouldReset();
    }, [JSON.stringify(initialValues)]);
};
